/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/refresh_medium'
export default icon
